import React from 'react'

const HubStorageTabLoadableComponent = React.lazy(() => import('./HubStorageTableComponent'))
const DailyHubScanTabLoadableComponent = React.lazy(() => import('./DailyHubScanTableComponent'))

export {
	HubStorageTabLoadableComponent, 
	DailyHubScanTabLoadableComponent
}